import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import isEmpty from "../../../../store/validation/is-Empty";
import { Modal, Image, Button } from "react-bootstrap";
import {
  create_and_update_restaurant,
  create_restaurant_chains,
} from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import axios from "axios";
import { serverApi } from "../../../../config/Keys";
import Alert from "react-s-alert";
// import { RestaurantChainSettings } from "../../../../store/validation/allValidationFile/onboardingProcessValidation/RestaurantChainSettings";

// COMPONENTS
import RestaurantChainWrapperComponent from "./RestaurantChainWrapperComponent";
import RestaurantChainToggle from "./RestaurantChainSelectToggle";
import RestaurantChainListComponent from "./RestaurantChainsListComponent";
import RestaurantChainAddComponent from "./RestaurantChainAddComponent";
import Media from "react-media";
import { SliderMobileReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderMobileReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { RESTAURANT_CHAIN } from "../../../../store/types";
import store from "../../../../store/store";

const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

export class RestaurantChainsOnboardingComponent extends Component {
  constructor() {
    super();
    this.state = {
      actionButton: false,
      loader: false,
      localizationText: "",
      restaurant_chain_id: "",
      all_restaurant_chains: [],
      location_code: "",
      suggestlocation_code: "",
      are_you_part_of_chain: false,
      is_suggest_new_open: false,
      title: "",
      icon: "",
      address: "",
      area: "",
      city: "",
      pinCode: "",
      phone_numbers: [{ country_code: "", mobile_no: "" }],
      enquiry_emails: [" "],
      emailError: "",
      phoneError: "",
      status: "NOTAPPROVED",
      search: "",
      errors: {},
      country_code: "",
      formShow: false,
      chainCategory: "",
      onChainSuccess: false,
    };
  }

  // CONSTANTS:
  // FOR STATUS USE --> NOTAPPROVED, APPROVED
  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
    let formData = {
      vendor_id: this.props.auth.user.VendorUser._id,
    };
    this.props.create_and_update_restaurant(formData);

    let phone_numbers = [{ country_code: "", mobile_no: "" }];
    axios
      .get("https://ipapi.co/json")
      .then((result) => {
        phone_numbers[0].country_code = result.data.country_calling_code;
        this.setState({
          country_code: result.data.country_calling_code,
          isLoading: false,
          phone_numbers: phone_numbers,
        });
      })
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );

    let suggestChain = JSON.parse(localStorage.getItem("suggestChain"));
    if (!isEmpty(suggestChain)) {
      store.dispatch({
        type: RESTAURANT_CHAIN,
        payload: suggestChain,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    // console.log(nextProps.chainlist);
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.auth.user.VendorUser) &&
      !isEmpty(nextProps.auth.user.VendorUser.country_code) &&
      !isEmpty(nextProps.chainlist) &&
      !nextState.hasSetMapProps
    ) {
      return {
        localizationText: !isEmpty(
          nextProps.auth.user.VendorUser.country_code +
            nextProps.auth.user.VendorUser.country
        )
          ? nextProps.auth.user.VendorUser.country_code +
            nextProps.auth.user.VendorUser.country
          : "+91IN",
        restaurant_chain_id: !isEmpty(nextProps.onboarding.restaurant_chain_id)
          ? !isEmpty(nextProps.onboarding.restaurant_chain_id._id)
            ? nextProps.onboarding.restaurant_chain_id._id
            : nextProps.onboarding.restaurant_chain_id
          : "",
        location_code: !isEmpty(nextProps.onboarding.location_code)
          ? nextProps.onboarding.location_code
          : "",
        // are_you_part_of_chain: nextProps.onboarding.restaurant_chain_id
        //   ? true
        //   : false,
        are_you_part_of_chain:
          !isEmpty(nextProps.onboarding) &&
          !isEmpty(nextProps.onboarding.partofchains)
            ? nextProps.onboarding.partofchains
            : false,
        all_restaurant_chains: nextProps.chainlist.filter(
          (chain) => chain.status !== "NOTAPPROVED"
        ),
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    let suggestChain = JSON.parse(localStorage.getItem("suggestChain"));
    if (!isEmpty(suggestChain)) {
      return {
        all_restaurant_chains:
          suggestChain !== undefined && suggestChain !== null
            ? suggestChain
            : nextProps.chainlist,
      };
      // store.dispatch({
      //   type: RESTAURANT_CHAIN,
      //   payload:
      //     suggestChain !== undefined ? suggestChain : nextProps.chainlist,
      // });
    }
    return null;
  }

  onToggleHandler = (name, value) => (e) => {
    this.setState({
      [name]: value,
      actionButton: true,
    });
  };

  onChangeHandler = (e) => {
    let data = e.target.value.split(" ");
    let newarray1 = [];
    for (let x = 0; x < data.length; x++) {
      newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
    }
    let newData = newarray1.join(" ");
    this.setState({
      [e.target.name]: newData,
      actionButton: true,
    });
    // this.setState({
    //   [e.target.name]: e.target.value,
    //   actionButton: true,
    // });
  };

  handleChainCategory = (e) => {
    this.setState({
      chainCategory: e.target.value,
    });
  };

  onChangePinCode = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[
        e.target.name
      ] = `*Fields can’t be blank. Please enter your ${e.target.name}`;
    } else {
      delete errors[e.target.name];
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  onEmailChangeHandler = (index) => (e) => {
    let enquiry_emails = this.state.enquiry_emails;
    if (enquiry_emails.includes(e.target.value)) {
      alert("Email Already Exits");
    } else {
      enquiry_emails[index] = e.target.value;
      this.setState({
        enquiry_emails: enquiry_emails,
        emailError: "",
        actionButton: true,
      });
    }
  };

  onPhoneDataChangeHandler = (name, index) => (e) => {
    let phone_numbers = this.state.phone_numbers;
    if (phone_numbers.some((diner) => diner.mobile_no === e.target.value)) {
      alert("Phone Number Already Exits");
    } else {
      if (name === "mobile_no") {
        phone_numbers[index][name] = e.target.value.slice(0, 10);
      } else {
        phone_numbers[index][name] = e.target.value;
      }
      this.setState({
        phone_numbers: phone_numbers,
        phoneError: "",
        actionButton: true,
      });
    }
  };

  onEmailPhoneAddDeleteHandler = (name, operation, index) => (e) => {
    e.preventDefault();
    let errorPopup = false;
    let errorPopupPhone = false;
    if (name === "phone") {
      if (operation === "add") {
        let phone_numbers = this.state.phone_numbers;
        if (
          phone_numbers[phone_numbers.length - 1].mobile_no === "" ||
          phone_numbers[phone_numbers.length - 1].mobile_no.length < 10
        ) {
          errorPopupPhone = true;
          this.setState({ errors: {} });
        } else {
          phone_numbers.push({
            country_code: this.state.country_code,
            mobile_no: "",
          });
          this.setState({ phone_numbers: phone_numbers, errors: {} });
        }
      } else {
        let phone_numbers = this.state.phone_numbers;
        if (phone_numbers.length === 1) {
          errorPopupPhone = true;
          this.setState({ errors: {} });
        } else {
          phone_numbers.splice(index, 1);
          this.setState({ phone_numbers: phone_numbers, errors: {} });
        }
      }
    } else if (name === "email") {
      if (operation === "add") {
        let enquiry_emails = this.state.enquiry_emails;
        if (!validEmailRegex.test(enquiry_emails[enquiry_emails.length - 1])) {
          errorPopup = true;
          this.setState({ errors: {} });
        } else {
          enquiry_emails.push("");
          this.setState({ enquiry_emails: enquiry_emails, errors: {} });
        }
      } else {
        let enquiry_emails = this.state.enquiry_emails;
        if (enquiry_emails.length === 1) {
          errorPopup = true;
          this.setState({ errors: {} });
        } else {
          enquiry_emails.splice(index, 1);
          this.setState({ enquiry_emails: enquiry_emails, errors: {} });
        }
      }
    } else {
    }
    if (errorPopup === true) {
      const { errors } = this.state;
      if (e.target.value === "") {
        errors.email = `email is required`;
      } else {
        delete errors[e.target.name];
        this.setState({ errors: {} });
      }
      this.setState({
        errors: errors,
      });
    } else if (errorPopupPhone === true) {
      const { errors } = this.state;
      if (e.target.value === "") {
        errors.mobile_no = `phone number is required`;
      } else {
        delete errors[e.target.name];
        this.setState({ errors: {} });
      }
      this.setState({
        errors: errors,
      });
    }
  };

  onSingleImageDrop = (picture) => {
    this.setState({
      icon: picture,
      actionButton: true,
    });
  };

  onBackButtonSuggestNew = (e) => {
    this.setState({
      is_suggest_new_open: false,
    });
  };

  onBackButtonChainPage = (e) => {
    this.setState({
      are_you_part_of_chain: false,
    });
  };

  /**************************************
   * @DESC - ON IMAGE UPLOAD HANDLER
   * @DESC - USER DEFINED METHODS
   **************************************/

  onCompleteCrop = (url) => {
    this.setState({
      icon: url,
      logo_main: null,
      singleImageLoader: false,
      actionButton: true,
    });
  };

  onCancelCrop = () => {
    this.setState({ logo_main: null });
  };
  onImageLogoUploadHandler = (e) => {
    // this.setState({ loader: true });
    const vendor_id = this.props.auth.user.VendorUser._id;
    const restaurant_name = this.props.onboarding?.restaurant_name?.split(" ").join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    data.append("files", e.target.files[0]);

    this.setState({
      logo_main: e.target.files[0],
      combined: combined,
    });
    // axios
    //   .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data, {
    //     headers: {
    //       "content-type": "multipart/form-data",
    //     },
    //   })
    //   .then((res) => {
    //     this.setState({ icon: res.data, loader: false });
    //     Alert.success(`<h4>Restaurant Chain Image Upload Successfully</h4>`, {
    //       position: "top-right",
    //       effect: "bouncyflip",
    //       beep: true,
    //       html: true,
    //       timeout: 3000,
    //       offset: 35,
    //     });
    //   })
    //   .catch((err) => {
    //     this.setState({ loader: false });
    //     Alert.error(`<h4>Error while uploading the image</h4>`, {
    //       position: "top-right",
    //       effect: "bouncyflip",
    //       beep: true,
    //       html: true,
    //       timeout: 3000,
    //       offset: 35,
    //     });
    //   });
    e.target.value = "";
  };

  removeFile = (e) => {
    let removeIconImage = this.state.icon;
    removeIconImage = "";
    this.setState({
      icon: removeIconImage,
      actionButton: true,
    });
  };

  onWithOutApiCall = (e) => {
    this.props.history.push("/restauranttype");
  };

  onhandleSubmit = (e) => {
    if (
      this.props.onboarding &&
      this.props.onboarding.restaurant_chain_id !== "" &&
      this.props.onboarding.restaurant_chain_id !== undefined &&
      this.props.onboarding.restaurant_chain_id !== null
    ) {
      let formData = {
        vendor_id: this.props.onboarding.vendor_id,
        restaurant_chain_id: this.state.restaurant_chain_id,
        partofchains: this.state.are_you_part_of_chain,
        location_code: this.state.location_code,
        id: this.props.onboarding._id,
      };
      this.props.create_and_update_restaurant(formData);
      this.props.history.push("/restauranttype");
    } else {
      let formData = {
        vendor_id: this.props.onboarding.vendor_id,
        restaurant_chain_id: this.state.restaurant_chain_id,
        location_code: this.state.location_code,
        partofchains: this.state.are_you_part_of_chain,
        id: this.props.onboarding._id,
        page_completed_till: 5,
      };
      this.props.create_and_update_restaurant(formData);
      this.props.history.push("/restauranttype");
    }
  };

  onSuggestNewSubmitHandler = (e) => {
    let formData = {
      location_code: this.state.suggestlocation_code,
      chainCategory: this.state.chainCategory,
      title: this.state.title,
      icon: this.state.icon.toString(),
      address: this.state.address,
      area: this.state.area,
      city: this.state.city,
      zip_code: this.state.pinCode,
      phone_numbers: this.state.phone_numbers,
      enquiry_emails: this.state.enquiry_emails,
      status: "NOTAPPROVED",
      // page_completed_till: 5,
    };
    this.props.create_restaurant_chains(
      formData,
      (data) => this.onSuccess(data),
      (err) => this.onError(err)
    );
    // console.log(formData);
  };

  onSuccess = (data) => {
    let chainList = this.state.all_restaurant_chains;
    let newChainData = data;
    newChainData.status = "APPROVED";
    chainList.push(newChainData);
    localStorage.setItem("suggestChain", JSON.stringify(chainList));
    store.dispatch({
      type: RESTAURANT_CHAIN,
      payload: chainList,
    });
    this.setState({
      onChainSuccess: true,
    });
  };

  onError = (err) => {
    Alert.error(`<h4>${err.response.data.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  handleCloseSuccess = (e) => {
    this.setState({
      onChainSuccess: false,
      is_suggest_new_open: false,
    });
    // this.props.history.push("/restauranttype");
  };

  localProps = {
    onWithOutApiCall: this.onWithOutApiCall,
    onBackButtonChainPage: this.onBackButtonChainPage,
    onBackButtonSuggestNew: this.onBackButtonSuggestNew,
    onhandleSubmit: this.onhandleSubmit,
    onSuggestNewSubmitHandler: this.onSuggestNewSubmitHandler,
    onToggleHandler: this.onToggleHandler,
    onChangeHandler: this.onChangeHandler,
    onChangePinCode: this.onChangePinCode,
    onFocusOut: this.onFocusOut,
    onImageLogoUploadHandler: this.onImageLogoUploadHandler,
    removeFile: this.removeFile,
    onEmailChangeHandler: this.onEmailChangeHandler,
    onSingleImageDrop: this.onSingleImageDrop,
    onEmailPhoneAddDeleteHandler: this.onEmailPhoneAddDeleteHandler,
    onPhoneDataChangeHandler: this.onPhoneDataChangeHandler,
    onCompleteCrop: this.onCompleteCrop,
    onCancelCrop: this.onCancelCrop,
    handleChainCategory: this.handleChainCategory,
  };
  handleFormShow = () => {
    this.setState({ formShow: true });
  };
  handleFormHide = () => {
    this.setState({ formShow: false });
  };
  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    const { formShow } = this.state;
    return (
      <>
        <Media query="(max-width: 991px)">
          <>
            {!formShow && (
              <div className="bg-white min-height-100vh position-relative">
                <div className="mobileFirstScreen col-12">
                  <SliderMobileReusableComponent
                    displayShow={true}
                    selectedProgressBarOne="active"
                    backLink={true}
                    onLink={"/restaurantinfo"}
                    paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-06.svg")}
                  />
                </div>
                <div className="col-12 py-4">
                  <div className="f24_700_HelveticaNeue">Business Chain</div>
                  {/* <div className="f16-400 opacity5">
                    Enter the details about your Business location
                  </div> */}
                </div>
                <div className="border-top d-flex justify-content-center align-items-center p-3 fixed-bottom bg-white">
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    link={"/restaurantinfo"}
                  />
                  <ReusableOnboardingButton
                    buttonType="button"
                    buttonTitle="Next"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                    buttonText="Next"
                    onClick={this.handleFormShow}
                  />
                </div>
              </div>
            )}
          </>
        </Media>
        <div className={`formShow ${formShow ? "active" : ""}`}>
          <RestaurantChainWrapperComponent
            localProps={this.localProps}
            state={this.state}
            {...this.props}
            handleFormHide={this.handleFormHide}
          >
            {this.state.is_suggest_new_open === false ? (
              <RestaurantChainToggle
                state={this.state}
                localProps={this.localProps}
              />
            ) : null}
            {this.state.are_you_part_of_chain === true &&
            this.state.is_suggest_new_open === false ? (
              <RestaurantChainListComponent
                state={this.state}
                localProps={this.localProps}
              />
            ) : null}
            {this.state.are_you_part_of_chain === true &&
            this.state.is_suggest_new_open === true ? (
              <RestaurantChainAddComponent
                state={this.state}
                localProps={this.localProps}
              />
            ) : null}
          </RestaurantChainWrapperComponent>
        </div>
        <Modal
          show={this.state.onChainSuccess}
          onHide={this.handleCloseSuccess}
          centered
          backdrop="static"
        >
          <Modal.Header
            className="border-0 f20_700_HelveticaNeue justify-content-center"
            style={{ color: "#4caf50" }}
            closeButton
          >
            Chain Business Setup Successfully
          </Modal.Header>
          <Modal.Body className="text-center">
            <Image
              className="w-75 mb-4"
              src={require("../../../../assets/images/UserManagement/varified.svg")}
            />
            <div
              style={{ color: "#4caf50", width: "80%" }}
              className="f20_700_HelveticaNeue m-auto text-center pb-4"
            >
              Your Chain business is currently under verification.
            </div>
            <div className="f12-500 pb-4" style={{ color: "#212121" }}>
              Your suggested chain setup will be in pending status until
              approved. You will be notified when it is verified and approved.
              It will be temporarily displayed in the 'select your chain'
              section and will be discovered on the user app only after
              approval.
            </div>
            <div className="row justify-content-center">
              <div className="col-6">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  // style={{ width: "90%" }}
                  onClick={this.handleCloseSuccess}
                >
                  Okay
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  storage: state.storage,
  onboarding: state.onboarding.restaurantDetails,
  chainlist: state.category.restaurant_chain,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
  create_restaurant_chains,
})(withRouter(RestaurantChainsOnboardingComponent));
